import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';

import accessManagement from 'saga/accessManagement/ducks';
import acl from 'saga/acl/exports';
import addressSearch from 'saga/addressSearch/ducks';
import apiClient from 'saga/apiClient/ducks';
import initialization from 'saga/appHandlers/ducks';
import auth from 'saga/auth/ducks';
import billingDetail from 'saga/billing/detail/ducks';
import billing from 'saga/billing/ducks';
import installment from 'saga/billing/installments/ducks';
import invoicesToPay from 'saga/billing/invoicesToPay/ducks';
import onlinePayment from 'saga/billing/onlinePayment/ducks';
import paymentsOverview from 'saga/billing/paymentsOverview/ducks';
import allInvoices from 'saga/billingManagement/allInvoices/ducks';
import claims from 'saga/billingManagement/claims/ducks';
import detailListView from 'saga/billingManagement/detailListView/ducks';
import detailRecordView from 'saga/billingManagement/detailRecordView/ducks';
import downloadDoDocument from 'saga/billingManagement/downloadDoDocument/ducks';
import downloadEbillDocument from 'saga/billingManagement/downloadEbillDocument/ducks';
import invoiceDetail from 'saga/billingManagement/invoiceDetail/ducks';
import summaryView from 'saga/billingManagement/summaryView/ducks';
import taxView from 'saga/billingManagement/taxView/ducks';
import codebook from 'saga/codebook/ducks';
import context from 'saga/context';
import customerAccount from 'saga/customerAccount/ducks';
import customerDetail from 'saga/customerDetail/ducks';
import customerRequest from 'saga/customerRequests/ducks';
import document from 'saga/document/ducks';
import filteredDocuments from 'saga/filteredDocuments/ducks';
import journaling from 'saga/journaling/ducks';
import kahl from 'saga/kahl/ducks';
import localStoreDocuments from 'saga/localStoreDocument/ducks';
import otp from 'saga/OTP/ducks';
import documentConsignment from 'saga/sendingCreation/ducks';
import sharedObjects from 'saga/sharedObjects/ducks';
import translation from 'saga/translation/ducks';
import lastUserActivity from 'saga/userActivity/ducks';

export const history = createBrowserHistory();

const rootReducer = combineReducers({
  router: connectRouter(history),
  context,
  auth,
  apiClient,
  sharedObjects,
  journaling,
  document,
  filteredDocuments,
  documentConsignment,
  downloadEbillDocument,
  downloadDoDocument,
  kahl,
  codebook,
  localStoreDocuments,
  billing,
  installment,
  billingDetail,
  onlinePayment,
  acl,
  initialization,
  accessManagement,
  addressSearch,
  customerDetail,
  customerAccount,
  customerRequest,
  translation,
  lastUserActivity,
  detailListView,
  taxView,
  claims,
  otp,
  invoiceDetail,
  detailRecordView,
  summaryView,
  paymentsOverview,
  allInvoices,
  invoicesToPay,
});

export default rootReducer;
